/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-next-line import/no-cycle
import api from '@src/api';
import { Observable } from 'rxjs';
import { Action } from 'redux-actions';
import { BatchApprovalPayload, BatchApprovalTask, BatchApprovalTaskResult } from '@src/utils/batchApproval';

export const getLeaveApplications = (payload: {
	year: number;
	within: string;
	status: string;
}): Observable<Action> => (
	api.get('leave-applications/', payload)
);

export const postLeaveApplication = (payload: {
	start_at: string;
	end_at: string;
	leave_type: string;
	reason: string;
	attachment_ids: string[];
	deputy_user_id?: string;
}): Observable<Action> => (
	api.post('leave-applications/', payload)
);

// 申請人是否有職代簽核關卡、後台設定的職代清單
export const getLeaveApplicationInfo = (): Observable<Action> => (
	api.get('leave-applications/info')
);

// 所屬企業的在職員工（已排除離職、刪除、註冊中），供自選職代
export const getFrontDeskMembers = (): Observable<Action> => (
	api.get('members/front-desk')
);

export const getLeaveApplicationDetail = (payload: { id: string }): Observable<Action> => (
	api.get(`leave-applications/${payload.id}`)
);

export const postLeaveApplicationApprove = (payload: {
	id: string;
	comments: string;
  is_approved: boolean;
}): Observable<Action> => (
	api.post(`leave-applications/${payload.id}/approve`, payload)
);

export const getLeaveApplicationConfirm = (payload: { id: string }): Observable<Action> => (
	api.get(`leave-applications/${payload.id}/confirm`)
);

export const postLeaveApplicationConfirm = (payload: {
	id: string;
	confirmed_start_at: string;
	confirmed_end_at: string
}): Observable<Action> => (
	api.post(`leave-applications/${payload.id}/confirm`, payload)
);

export const postLeaveApplicationWithdraw = (payload: { id: string }): Observable<Action> => (
	api.post(`leave-applications/${payload.id}/withdraw`)
);

export const getLeaveApplicationsApproverView = (payload: {
	year: number;
	within: string;
	status: string;
	waiting_only: boolean
}): Observable<Action> => (
	api.get('leave-applications/approver_view', payload)
);

export const postLeaveApplicationWithdrawApproval = (payload: { id: string }): Observable<Action> => (
	api.post(`leave-applications/${payload.id}/withdraw_approval`)
);

export const postLeaveApplicationsBatchApprove = (
	{ application_ids, is_approved }: BatchApprovalPayload,
): Promise<BatchApprovalTask> => (
	api.post('leave-applications/batch-approve', { application_ids, is_approved })
);

export const getLeaveApplicationsBatchApprove = (
	{ batch_approval_task_id }: BatchApprovalTask,
): Promise<BatchApprovalTaskResult> => (
	api.get(`leave-applications/batch-approve/${batch_approval_task_id}`)
);

export const deleteLeaveApplicationAttachment = (payload: { id: string }): Observable<Action> => (
	api['delete'](`leave-applications/attachments/${payload.id}`)
);

export const postLeaveApplicationAttachments = (payload: {
	id: string;
	attachment_ids: string[];
}): Observable<Action> => (
	api.post(`leave-applications/${payload.id}/attachments`, { attachment_ids: payload.attachment_ids })
);

export const getAvailableLeaveTypes = (payload: {
	start_at: string | number;
	end_at: string | number;
	onSuccess?: (res: unknown) => void;
	onError?: (error: unknown) => void;
}): Observable<Action> => {
	const { onSuccess, onError, ...params } = payload;
	return api.get('leave-entitlements/front-desk/available-leave-types', params);
};

export const getLeaveApplicationsTotalMinutes = (payload: {
	start_at: string;
	end_at: string;
	leave_type: string;
	user_id?: string;
}): Observable<Action> => (
	api.get('leave-applications/total_minutes', payload)
);

export const getLeaveEntitlement = (payload: { leave_category: string }): Observable<Action> => {
	const params = payload.leave_category === 'special' ? { leave_category: ['special', 'custom'] } : payload;
	const searchParams = new URLSearchParams();

	if (Array.isArray(params.leave_category)) {
		params.leave_category.forEach(value => {
			searchParams.append('leave_category', value);
		});
	} else {
		searchParams.append('leave_category', params.leave_category);
	}

	return api.get(`leave-entitlements/front-desk?${searchParams.toString()}`);
};

export const getLeaveEntitlementByLeaveType = (payload: { leave_type: string }): Observable<Action> => (
	api.get(`/leave-entitlements/front-desk/leave-types/${payload.leave_type}`, payload)
);

export const getLeaveApplicationAttachmentDownloadLink = (payload: { id: string }): Observable<Action> => (
	api.get(`leave-applications/attachments/${payload.id}/download_link`)
);

export const getLeaveApplicationsInfoByLeaveType = (payload: { leaveType: string, onSuccess?: () => void, onError?: () => void }): Observable<Action> => {
	const { onSuccess, onError, ...other } = payload;
	return (
		api.get(`leave-applications/info/${payload.leaveType}`, other)
	);
};

export const getCustomLeaveTypeRules = (): Observable<Action> => (
	api.get('time-off-rule-sets/special-custom-leave-type-rules/mine')
);

export const postLeaveApplicationsGrantNewEntitlement = (payload: {
	leave_type: string;
	amount: number;
}): Observable<Action> => (
	api.post('leave-applications/grant-new-entitlement', payload)
);
